import collectiveApi from 'modules/common/collectiveApi';

/*
 * collectiveApi defaults Content-Type to application/json, and axios reacts to that header by
 * JSON-stringifying a FormData body (formDataToJSON) instead of sending multipart — the receipt
 * File serializes to `{}` and the endpoint rejects the payment. Declaring multipart here lets
 * the FormData through; the XHR adapter then swaps in the browser's boundary-stamped header.
 */
const multipartConfig = { headers: { 'Content-Type': 'multipart/form-data' } };

const createTaxPayment = async (payload) => {
    const { data } =
        payload instanceof FormData
            ? await collectiveApi.post(`/qte/member-tax-payments/`, payload, multipartConfig)
            : await collectiveApi.post(`/qte/member-tax-payments/`, payload);
    return data;
};

export default createTaxPayment;
